import { inject } from 'vue'
import { useNotification } from '@/composables/useNotification.js'
import { useWishlists } from '@/composables/useWishlists.js'
import { useCustomerStore } from '@/stores/customer.js'
import { useUiStore } from '@/stores/ui.js'

export function useCustomer() {
  const cl = inject('cl')

  const notification = useNotification()
  const uiStore = useUiStore()
  const customerStore = useCustomerStore()
  const { wishlistsInitStore } = useWishlists()

  const customerIncludes = ['customer_addresses.address', 'tags', 'sku_lists.sku_list_items.sku']

  async function loadCustomerByEmail(email) {
    const customerList = await cl.customers.list({
      include: customerIncludes,
      filters: { email_eq: `${email}` }
    })

    const customer = customerList.length > 0 ? customerList[0] : false

    if (customer?.sku_lists) {
      wishlistsInitStore(customer.sku_lists, customer)
    }

    return customer
  }

  async function loadCustomerById(id) {
    const customer = await cl.customers.retrieve(id, {
      include: customerIncludes
    })

    if (customer?.sku_lists) {
      wishlistsInitStore(customer.sku_lists, customer)
    }

    return customer?.id ? customer : false
  }

  async function loadCustomersByEmailBulk(emails, include = [], fields) {
    // did not use clutils because i was not sure if i can filter
    // e.g. filters: { email_in: emails.join(',') }
    const batchSize = 25
    const allCustomers = []
    
    for (let i = 0; i < emails.length; i += batchSize) {
      const batch = emails.slice(i, i + batchSize)
      try {
        const customers = await cl.customers.list({
          include,
          fields,
          filters: { email_in: batch.join(',') },
          pageSize: batchSize
        })
        allCustomers.push(...customers)
      } catch (error) {
        console.error(`Failed to fetch batch ${i / batchSize + 1}:`, error)
      }
    }
    
    return allCustomers
  }

  async function openCustomerOrderDetails(orderId, email) {
    let customer = false
    if (email) {
      customer = await loadCustomerByEmail(email)
    }

    if (!customer) {
      notification.showNotification({
        message: 'Customer could not be loaded.',
        variant: 'danger',
        duration: 6000,
        icon: 'person-x'
      })
      return
    }

    customerStore.setCustomer(customer)
    customerStore.customerOrderId = orderId
    uiStore.$patch({
      showCustomerOrderDetails: true
    })
  }

  return {
    loadCustomerByEmail,
    loadCustomerById,
    openCustomerOrderDetails,
    loadCustomersByEmailBulk
  }
}
